/* eslint-disable @nx/enforce-module-boundaries */
import { EnvironmentProviders, Provider } from '@angular/core';

import { FreeBetsBadgeService, VanillaApiService } from '@frontend/oxygen/vanillainit';
import { ApiServiceFactory, ClientConfigProductName, MENU_COUNTERS_PROVIDER, ProductService } from '@frontend/vanilla/core';

declare global {
    interface Window {
        cmsInitPromise: Promise<any>;
    }
}

export function apiServiceFactory(service: ApiServiceFactory, productService: ProductService) {
    return service.create(VanillaApiService, {
        product: 'ozone',
        area: 'coralsports',
        forwardProductApiRequestHeader: productService.getMetadata(ClientConfigProductName.OZONE).isEnabled,
    });
}

export function provideCoralSportsFeatures(): (Provider | EnvironmentProviders)[] {
    return [
        { provide: 'CMS_CONFIG', useValue: (window as any)['cmsInitPromise'] },
        { provide: MENU_COUNTERS_PROVIDER, useExisting: FreeBetsBadgeService, multi: true },
        { provide: VanillaApiService, deps: [ApiServiceFactory, ProductService], useFactory: apiServiceFactory },
    ];
}
